import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';
import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { UniDriverFactory } from '@wix/wix-ui-test-utils/uni-driver-factory';

export interface ModalUniDriver extends BaseUniDriver {
  isOpen: () => Promise<boolean>;
  getChildBySelector: (selector: string) => Promise<UniDriver | null>;
  isScrollable: () => Promise<boolean>;
  closeButtonExists: () => Promise<boolean>;
  clickOnOverlay: () => Promise<void>;
  clickOnCloseButton: () => Promise<void>;
  clickOnNavigationPrevious: () => Promise<void>;
  clickOnNavigationNext: () => Promise<void>;
  navigationPreviousExists: () => Promise<boolean>;
  navigationNextExists: () => Promise<boolean>;
  getNavigationPreviousLabel: () => Promise<string>;
  getNavigationNextLabel: () => Promise<string>;
  getContent: () => Promise<Element>;
  getContentStyle: () => Promise<any>;
  getContentLabel: () => Promise<string | null>;
  getZIndex: () => Promise<any>;
}

declare const modalUniDriverFactory: UniDriverFactory<ModalUniDriver>;
